/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_KontoinhaberInputs */

const de__field_kontoinhaber = /** @type {(inputs: _Field_KontoinhaberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontoinhaber`)
};

/**

* @param {_Field_KontoinhaberInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_kontoinhaber = /** @type {((inputs?: _Field_KontoinhaberInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_KontoinhaberInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kontoinhaber(inputs)
});